import _regeneratorRuntime from "D:\\workFile\\qingbeiCode\\qingbei-pc\\node_modules\\@babel\\runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TestCheckModal from "../member/components/TestCheckModal";
export default {
  name: "TestDetail",
  components: {
    TestCheckModal: TestCheckModal
  },
  data: function data() {
    return {
      id: this.$route.query.id,
      tableTitle: [{
        type: 1,
        value: "单选题"
      }, {
        type: 2,
        value: "判断题"
      }, {
        type: 3,
        value: "多选题"
      }, // { type: 4, value: "不定项选择题" },
      {
        type: 5,
        value: "简答题"
      }, {
        type: 6,
        value: "材料题"
      }, {
        type: 7,
        value: "填空题"
      }],
      introduce: [{
        label: "答卷时长",
        value: "",
        id: "time",
        unit: "分钟"
      }, {
        label: "试题总数",
        value: "",
        id: "ques_num",
        unit: "题"
      }, {
        label: "考试分数",
        value: "",
        id: "score",
        unit: "分"
      }, {
        label: "通过分数",
        value: "",
        id: "pass_score",
        unit: "分"
      }],
      testInfo: {
        introduce: []
      }
    };
  },
  created: function created() {
    this.getTestInfo();
  },
  methods: {
    getTestInfo: function () {
      var _getTestInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var res, count, score;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$http.get("/api/app/test/entranceTest/".concat(this.id));

              case 2:
                res = _context.sent;
                count = 0, score = 0;
                res.info.forEach(function (i) {
                  i.title = _this.getTitle(i.type);
                  count += i.count;
                  score += i.score;
                });
                res.info.push({
                  title: "总计",
                  count: count,
                  score: score
                });
                this.testInfo = res;
                res.time = res.time / 60; //答卷时长，单位是秒

                this.testInfo.introduce = this.introduce.map(function (i) {
                  if (i.id == "time" && !res[i.id]) {
                    return _objectSpread({}, i, {
                      value: "不限制",
                      unit: ""
                    });
                  }

                  return _objectSpread({}, i, {
                    value: res[i.id]
                  });
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getTestInfo() {
        return _getTestInfo.apply(this, arguments);
      }

      return getTestInfo;
    }(),
    getTitle: function getTitle(type) {
      var data = this.tableTitle.find(function (i) {
        return i.type == type;
      }) || {};
      return data.value;
    },
    goToTest: function () {
      var _goToTest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$http.post("/api/app/practice/report", {
                  type: 7,
                  test_id: this.id
                });

              case 2:
                data = _context2.sent;

                if (!(data.length === 0)) {
                  _context2.next = 6;
                  break;
                }

                this.$info("当前没有题目可以练习");
                return _context2.abrupt("return");

              case 6:
                _context2.next = 8;
                return this.$refs.checkModal.init(this.id);

              case 8:
                this.$router.push({
                  name: "TestDo",
                  query: {
                    id: data,
                    package_id: this.id
                  }
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function goToTest() {
        return _goToTest.apply(this, arguments);
      }

      return goToTest;
    }()
  }
};